<template>
  <div class="grid">
    <loading
      :active="isLoadingModel"
      :can-cancel="true"
      color="#173EA3"
      :is-full-page="fullPage"
    ></loading>
    <div class="col-12">
      <div class="card">
        <Breadcrumb :home="breadcrumbHome" :model="breadcrumbItems" />
        <Toast />

        <div class="p-fluid formgrid grid" style="margin-top: 2%">
            <div class="field col-12 md:col-2">
              <span class="p-float-label">
                <InputText v-model="center_name"> </InputText>
                <label>Center Name</label>
              </span>
            </div>

          <div class="field col-12 md:col-2">
              <span class="p-float-label">
                <Dropdown
                  id="status"
                  v-model="centertypeitem"
                  :options="centertypeitems"
                  :value="centertypeitems.id"
                  optionLabel="name"
                ></Dropdown>
                <label>Type</label>
              </span>
            </div>

            <div class="field col-12 md:col-2">
              <span class="p-float-label">
                <Dropdown
                  id="status"
                  v-model="center_status"
                  :options="dropdownItems"
                  :value="dropdownItems.value"
                  optionLabel="name"
                ></Dropdown>
                <label>Status</label>
              </span>
            </div>

            <div class="field col-12 md:col-2" v-if="user_key && (client_group_ids)
            ">
            <span class="p-float-label">
              <Dropdown style="width: 150px" id="state" filter v-model="client_id_search" :options="client_id_dropdown"
                optionLabel="name" :optionValue="code" @change="get_vehicle_type_master"></Dropdown>
              <label>Select Client</label>
            </span>
          </div>

            <div class="field col-12 md:col-2">
            <span class="p-float-label">
              <MultiSelect id="User" filter v-model="district_dropdownItem" :options="district_dropdownItems"
                optionLabel="name" @change="getBlockData">
              </MultiSelect>
              <label for="complaint_status">District</label>
            </span>
          </div>

          <div class="field col-12 md:col-2" v-if="showFirstFilter">
            <span class="p-float-label">
              <MultiSelect id="User" filter v-model="block_dropdownItem" :options="block_dropdownItems" optionLabel="name"
                 @change="get_panchayat">
              </MultiSelect>
              <label for="complaint_status">Block</label>
            </span>
          </div>

          <div class="field col-12 md:col-2" v-if="showFirstFilter">
            <span class="p-float-label">
              <MultiSelect id="Panchayat" filter v-model="panchayat_dropdownItem" :options="panchayat_dropdownItems" optionLabel="name"
                 @change="get_village(1)">
              </MultiSelect>
              <label for="complaint_status">Panchayat</label>
            </span>
          </div>

          
          <div class="field col-12 md:col-2" v-if="showFirstFilter">
            <MultiSelect v-model="village_dropdownItem" :options="village_dropdownItems" optionLabel="name" filter @filter="get_village"
             placeholder="Village">
            </MultiSelect>
          </div>

          <div class="field col-12 md:col-2">
              <Button
                icon="pi pi-search"
                v-tooltip.bottom="'Search'"
                @click="search(1)"
              />
                <button v-if="!showFirstFilter" style="color: blue; background: none; border: none" @click="show_filter()">
                  more ...
              </button>
            </div>
        </div>
          <!-- </template> -->
          <!-- <template v-slot:end> -->
            <!-- &nbsp;
              <json-excel :data="product">
                <Button
                  icon="pi pi-upload"
                  v-tooltip.bottom="'export'"
                  @click="exportCSV"
                />
              </json-excel> -->
          <!-- </template> -->
        <!-- </Toolbar> -->
        <DataTable :loading="loading" ref="dt" :lazy="true" :totalRecords="totalRecords" :paginator="true"
          :value="products" v-model:selection="selectedProducts" :dataKey="columns[0]" :rows="limit" :filters="filters"
          @page="onPage($event)"
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          :rowsPerPageOptions="[5, 10, 25, totalRecords]"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords}" responsiveLayout="scroll"
          style="font-size: 12px" :rowHover="true" showGridlines>
          <template #empty>
            <b style="text-align: center">No records found.</b>
          </template>
          <template #header>
            <div class="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
              <h5 class="m-0"><b> Garbage Processing Center</b></h5>
              <!-- Total Records:{{totalRecords}} -->
              <div>
                <Button icon="pi pi-refresh" @click="search(2)" v-tooltip.bottom="'Refresh'" />&nbsp;
                <Button icon="pi pi-plus" v-tooltip.bottom="'Add'" @click="openNew" />
              </div>
            </div>
            <div style="text-align: right; font-weight: bold">
              <span>Total Centers:</span>{{ totalRecords }}
            </div>
          </template>
          <Column header="Status" style="min-width: 8rem; text-align: center" :field="columns[5]">
            <template #body="{ data }">
              <span v-if="data.status == 'Active' || data.status == 'active'">
                <badge :value="data.status" severity="success"></badge>
              </span>
              <span v-else-if="data.status == 'InActive' || data.status == 'In Active'
                ">
                <badge :value="data.status" severity="warning"></badge>
              </span>
              <span v-else-if="data.status == 'Delete' || data.status == 'Deleted'">
                <badge :value="data.status" severity="danger"></badge>
              </span>
              <span v-else>-</span>
            </template>
          </Column>
          <Column header="Sr No" style="min-width: 5rem; text-align: center">
            <template #body="{ index }">
              <span v-if="page_no == 1">{{ +index + +1 }}</span>
              <span v-else>{{ +index + 1 + limit * (page_no - 1) }}</span>
            </template>
          </Column>
          <Column header="Center Name" field="center_name" style="min-width: 5rem">
            <template #body="{ data }">
              {{ data.center_name }}
            </template>
          </Column>
          <Column header="Center Type" field="center_type_name" style="min-width: 10rem">
            <template #body="{ data }">
              <span v-if="data.center_type_name">{{
                data.center_type_name
              }}</span>
              <span v-else>-</span>
            </template>
          </Column>
          <!-- <Column
            header="District"
            field="district_name"
            style="min-width: 10rem"
          >
            <template #body="{ data }">
              <span v-if="data.district_name"
                >{{ data.district_name }}({{ data.district_code }})</span
              >
              <span v-else>-</span>
            </template>
          </Column>
          <Column header="Block" field="block_name" style="min-width: 10rem">
            <template #body="{ data }">
              <span v-if="data.block_name"
                >{{ data.block_name }}({{ data.block_code }})</span
              >
              <span v-else>-</span>
            </template>
          </Column>
          <Column
            header="Panchyat"
            field="panchayat_name"
            style="min-width: 10rem"
          >
            <template #body="{ data }">
              <span v-if="data.panchayat_name"
                >{{ data.panchayat_name }}({{ data.panchayat_code }})</span
              >
              <span v-else>-</span>
            </template>
          </Column> -->
          <Column header="Action" headerStyle="min-width:10rem;">
            <template #body="slotProps">
              <Button icon="pi pi-pencil" class="p-button-rounded p-button-help mr-2" v-tooltip.bottom="'Edit'"
                @click="editProduct(slotProps.data)" />
              <Button v-if="slotProps.data.status != 'Deleted'" icon="pi pi-trash" v-tooltip.bottom="'Delete'"
                class="p-button-rounded p-button-warning mt-2" @click="confirmDeleteProduct(slotProps.data)" />
            </template>
          </Column>
        </DataTable>
        <Dialog header="Processing Center" v-model:visible="productDialog" :breakpoints="{ '960px': '75vw' }"
          :style="{ width: '70vw' }" :modal="true">
          <div class="col-12">
            <div class="card">
              <div class="p-fluid formgrid grid">
                <div class="field col-6 md:col-6" style="margin-top: 1%">
                  <span class="p-float-label">
                    <InputText id="center_name" type="text" v-model.trim="product.center_name" required="true" autofocus
                      :class="{
                        'p-invalid': submitted && !product.center_name,
                      }" />
                    <label for="center_name">Center Name</label>
                  </span>
                </div>
                <div class="field col-6 md:col-6" style="margin-top: 1%">
                  <span class="p-float-label">
                    <Dropdown id="status" v-model="selectstatus" :options="dropdownItems" :value="dropdownItems.value"
                      optionLabel="name" :class="{ 'p-invalid': submitted && !selectstatus }" required="true"></Dropdown>
                    <label for="status">Status</label>
                  </span>
                </div>
                <div class="field col-6 md:col-6" style="margin-top: 1%">
                  <span class="p-float-label">
                    <Dropdown id="add_center" v-model="add_center_type" :options="centertypeitems"
                      :value="centertypeitems.id" optionLabel="name" required="true"></Dropdown>
                    <label for="">Center Type</label>
                  </span>
                </div>
                <div class="field col-6 md:col-6" style="margin-top: 1%" v-if="client_group_ids && user_key">
                  <span class="p-float-label">
                    <Dropdown id="client_dropdownItem" v-model="client_dropdownItem" :options="client_dropdownItems"
                      :value="client_dropdownItems._id" optionLabel="client_name" required="true"></Dropdown>
                    <label for="">Clients</label>
                  </span>
                </div>
                <div class="field col-12 md:col-12" style="margin-top: 1%">
                  <label for="Location">Location</label>
                  <Dropdown @change="get_location" v-model="location_search" :options="location_dropdown"
                    optionLabel="name" filter @filter="dropdown_list" placeholder="Location">
                    <template #value="slotProps">
                      <div class="country-item country-item-value" v-if="slotProps.value">
                        <div>{{ slotProps.value.name }}</div>
                      </div>
                      <span v-else>
                        {{ slotProps.placeholder }}
                      </span>
                    </template>
                    <template #option="slotProps">
                      <span>{{ slotProps.option.name }}</span>
                    </template>
                  </Dropdown>
                </div>
                <div class="field col-12 md:col-6" style="margin-top: 1%">
                  <span class="p-float-label">
                    <MultiSelect id="User" filter v-model="district_dropdownItem" :options="district_dropdownItems"
                      optionLabel="name" display="chip" @change="getBlockData">
                    </MultiSelect>
                    <label for="District">District</label>
                  </span>
                </div>
                <div class="field col-12 md:col-6" style="margin-top: 1%">
                  <span class="p-float-label">
                    <MultiSelect id="User" filter display="chip" v-model="block_dropdownItem"
                      :options="block_dropdownItems" optionLabel="name" placeholder="Block" @change="get_panchayat">
                    </MultiSelect>
                    <label for="Block">Block</label>
                  </span>
                </div>
                <div class="field col-12 md:col-6" style="margin-top: 1%">
                  <span class="p-float-label">
                    <MultiSelect id="User" filter display="chip" v-model="panchayat_dropdownItem"
                      :options="panchayat_dropdownItems" optionLabel="name" placeholder="Panchayat"
                      @change="get_village(1)">
                    </MultiSelect>
                    <label for="Panchayat">Panchayat</label>
                  </span>
                </div>
                <div class="field col-12 md:col-6" style="margin-top: 1%;">
                  <span class="p-float-label">
                    <MultiSelect v-model="village_dropdownItem" :options="village_dropdownItems" optionLabel="name" filter
                      display="chip" :maxSelectedLabels="3" @filter="get_village">
                    </MultiSelect>
                    <label for="Village">Village</label>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <template #footer>
            <Button v-if="product._id" label="Update" @click="add_update_center" icon="pi pi-check"
              class="p-button-warning" />
            <Button v-else label="add" @click="add_update_center" icon="pi pi-check" class="p-button-warning" />
          </template>
        </Dialog>
        <!-- 
  -----------------------------------------------------------------------------------------------------------   -->
        <Dialog v-model:visible="deleteProductDialog" :style="{ width: '450px' }" header="Confirm" :modal="true">
          <div class="flex align-items-center justify-content-center">
            <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem" />
            <span v-if="product">Are you sure you want to delete Center <b>{{ product.center_name }}</b>?</span>
          </div>
          <template #footer>
            <Button label="No" icon="pi pi-times" class="p-button-text" @click="deleteProductDialog = false" />
            <Button label="Yes" icon="pi pi-check" class="p-button-text" @click="deletecenter" />
          </template>
        </Dialog>
        <Dialog v-model:visible="deleteProductsDialog" :style="{ width: '450px' }" header="Confirm" :modal="true">
          <div class="flex align-items-center justify-content-center">
            <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem" />
            <span v-if="product">Are you sure you want to delete the selected products?</span>
          </div>
          <template #footer>
            <Button label="No" icon="pi pi-times" class="p-button-text" @click="deleteProductsDialog = false" />
            <Button label="Yes" icon="pi pi-check" class="p-button-text" @click="deleteSelectedProducts" />
          </template>
        </Dialog>
      </div>
    </div>
  </div>
</template>
<script>
import { FilterMatchMode } from "primevue/api";
import ProductService from "../service/ProductService";
//import JsonExcel from "vue-json-excel";
import BreadcrumbService from "../service/BreadcrumbService";
//import FormNewsMaster from "@/components/FormNewsMaster";

// import axios from "axios";
import apis from "@/apis";
import axios from "axios";
import { log } from "util";
export default {
  data() {
    return {
      client_group_ids: "",
      user_key: "",
      location_dropdown: [],
      location_search: "",
      place_details: "",
      state_dropdownItems: [
        { name: "Andhra Pradesh", value: "Andhra Pradesh" },
        { name: "Arunachal Pradesh", value: "Arunachal Pradesh" },
        { name: "Assam", value: "Assam" },
        { name: "Bihar", value: "Bihar" },
        { name: "Chhattisgarh", value: "Chhattisgarh" },
        { name: "Goa", value: "Goa" },
        { name: "Gujarat", value: "Gujarat" },
        { name: "Haryana", value: "Haryana" },
        { name: "Himachal Pradesh", value: "Himachal Pradesh" },
        { name: "Jharkhand", value: "Jharkhand" },
        { name: "Karnataka", value: "Karnataka" },
        { name: "Kerala", value: "Kerala" },
        { name: "Madhya Pradesh", value: "Madhya Pradesh" },
        { name: "Maharashtra", value: "Maharashtra" },
        { name: "Manipur", value: "Manipur" },
        { name: "Meghalaya", value: "Meghalaya" },
        { name: "Mizoram", value: "Mizoram" },
        { name: "Nagaland", value: "Nagaland" },
        { name: "Odisha", value: "Odisha" },
        { name: "Punjab", value: "Punjab" },
        { name: "Rajasthan", value: "Rajasthan" },
        { name: "Sikkim", value: "Sikkim" },
        { name: "Tamil Nadu", value: "Tamil Nadu" },
        { name: "Telangana", value: "Telangana" },
        { name: "Tripura", value: "Tripura" },
        { name: "Uttar Pradesh", value: "Uttar Pradesh" },
        { name: "Uttarakhand", value: "Uttarakhand" },
        { name: "West Bengal", value: "West Bengal" },
      ],
      state_dropdownItem: { name: "", value: "" },
      end_place_details: "",
      searchme: "",
      name: "",
      page_no: 1,
      isLoading: false,
      isLoadingModel: false,
      loading: false,
      fullPage: true,
      file_attachment: "",
      icon_dropdown: [],
      center_name: "",
      center_status: null,
      centertypeitems: this.$store.getters.getGarbageCenterTypes,
      centertypeitem: [],
      add_center_type: [],
      district_dropdownItem: null,
      district_dropdownItems: [],
      district_dropdownItem1: null,
      block_dropdownItem: null,
      block_dropdownItems: [],
      panchayat_dropdownItem: null,
      panchayat_dropdownItems: [],
      village_dropdownItems: [],
      village_dropdownItem: null,
      client_dropdownItem: "",
      showFirstFilter: false,
      client_dropdownItems: this.$store.getters.getClients,
      dropdownItems: [
        { name: "Active", value: "Active" },
        { name: "InActive", value: "InActive" },
        { name: "Deleted", value: "Deleted" },
      ],
      parent_dropdownItems: [],
      selectstatus: { name: "", value: "" },
      parent_selectstatus: { name: "", value: "" },
      pick_icon: { name: "", value: "" },
      products: null,
      productDialog: false,
      deleteProductDialog: false,
      deleteProductsDialog: false,
      lazyParams: {},
      product: {},
      selectedProducts: null,
      filters: {},
      offset: 1,
      limit: 10,
      columns: [],
      pageno: 1,
      submitted: false,
      icons: null,
      totalRecords: 0,
      id: "",
      BreadcrumbService: null,
      breadcrumbHome: {},
      breadcrumbItems: [],
    };
  },
  productService: null,
  async created() {
    this.productService = new ProductService();
    this.initFilters();
    this.showFirstFilter = false;
    this.BreadcrumbService = new BreadcrumbService();
    let Breadcrum_data = this.BreadcrumbService.getBreadcrum(
      "Garbage Centers",
      "/garbage_processing_center"
    ); 
    //
    //let Breadcrum_data = this.BreadcrumbService.menumaster();
    this.breadcrumbHome = Breadcrum_data.home;
    this.breadcrumbItems = Breadcrum_data.items;
    this.user_key = localStorage.getItem("user_key");
    this.client_group_ids = localStorage.getItem("client_group_ids");
    const district_master = this.$store.getters.getDistricts;
    if (district_master.length > 0) {
      this.district_dropdownItems = district_master.map((item) => ({
        name: item["name"],
        value: item["code"],
      }));
    }
    const block_master = this.$store.getters.getBlocks;
    if (block_master.length > 0) {
      this.block_dropdownItems = block_master.map((item) => ({
        name: item["name"],
        value: item["code"],
      }));
    }
    // const panchyat_master = this.$store.getters.getPanchyats;
    // if (panchyat_master.length > 0) {
    //   this.panchayat_dropdownItems = panchyat_master.map((item) => ({
    //     name: item["Local Body Name"],
    //     value: item["Local Body Code"],
    //   }));
    // }
    //await this.get_village(1);
  },
  async mounted() {
    this.id = this.$route.params.id;
    this.lazyParams = {
      first: 0,
      rows: this.limit,
      sortField: null,
      sortOrder: null,
      filters: this.filters,
    };
    if (this.totalRecords == 0) {
      await this.get_count();
    }
    await this.get_list();
  },
  watch: {
    async $route() {
      this.products = [];
      this.columns = [];
      this.totalRecords = 0;
      this.id = this.$route.params.id;
      if (this.id) {
        await this.get_count();
        this.get_list();
      }
    },
  },
  methods: {
    async get_village(search) {
      var district_code = [];
      var block_code = [];
      var panchayat_code = [];
      if (this.district_dropdownItem) {
        for (var d = 0; d < this.district_dropdownItem.length; d++) {
          district_code.push(this.district_dropdownItem[d].value);
        }
      }
      if (this.block_dropdownItem) {
        for (var c = 0; c < this.block_dropdownItem.length; c++) {
          block_code.push(this.block_dropdownItem[c].value);
        }
      }
      if (this.panchayat_dropdownItem) {
        for (var e = 0; e < this.panchayat_dropdownItem.length; e++) {
          panchayat_code.push(this.panchayat_dropdownItem[e].value);
        }
      }
      if (district_code.length == 0 && block_code.length == 0) {
        return false;
      }
      var data = {
        "count": false,
        "page_no": 1,
        "limit": 10000000,
        district_code: district_code,
        block_code: block_code,
        panchayat_code: panchayat_code
      };
      if (search != 1 && search != 2) {
        data.search_name = search.value;
      }
      var promise = apis.getVillageData(data);
      promise.then((response) => {
        this.village_dropdownItems = [];
        var temp = response.data.data;
        for (let a = 0; a < temp.length; a++) {
          this.village_dropdownItems.push({ name: temp[a].village_name, value: temp[a].village_code });
        }
        if (search == 2) {
          if (this.product.village_code && this.product.village_code.length > 0 && (this.district_dropdownItem.length > 0 || this.block_dropdownItem.length > 0 || this.panchayat_dropdownItem.length > 0)) {
            this.panchayat_dropdownItem = [];
            for (let w = 0; w < this.product.village_code.length; w++) {
              for (let h = 0; h < this.village_dropdownItems.length; h++) {
                if (
                  this.product.village_code[w] ==
                  this.village_dropdownItems[h].value
                ) {
                  this.panchayat_dropdownItem.push({
                    name: this.village_dropdownItems[h].name,
                    value: this.village_dropdownItems[h].value,
                  });
                }
              }
            }
          }
        }
      });
    },

    show_filter() {
      this.showFirstFilter = true;
    },

    async filterJsonByDistrictAndBlockCodes(
      districtCodes,
      subdistrictCodes,
      jsonData
    ) {
      if (districtCodes.length == 0 && subdistrictCodes == 0) {
        return jsonData;
      } else {
        return jsonData
          .filter((item) => {
            return (
              districtCodes.includes(item["District Code"]) &&
              subdistrictCodes.includes(item["Subdistrict Code"])
            );
          })
          .map((item) => item);
      }
    },
    async get_panchayat(flag) {
      var district_code = [];
      var block_code = [];
      if (this.district_dropdownItem) {
        for (var d = 0; d < this.district_dropdownItem.length; d++) {
          district_code.push(this.district_dropdownItem[d].value);
        }
      }
      if (this.block_dropdownItem) {
        for (var c = 0; c < this.block_dropdownItem.length; c++) {
          block_code.push(this.block_dropdownItem[c].value);
        }
      }
      if (district_code.length == 0 && block_code.length == 0) {
        return false;
      }
      let payload = {
        "district_code": district_code,
        "block_code": block_code,
        "count": false,
        "page_no": 1,
        "limit": 28000
      };
      var promise = apis.getPanchayatData(payload);
      promise.then((response) => {
        var panchyats = response.data.data;
        this.panchayat_dropdownItems = panchyats.map(item => ({
          name: item['Local Body Name'],
          value: item['Local Body Code']
        }));
        if (flag && flag == 1) {
          if (this.product.grampanchayat_code && this.product.grampanchayat_code.length > 0) {
            this.panchayat_dropdownItem = [];
            for (let c = 0; c < this.product.grampanchayat_code.length; c++) {
              for (let k = 0; k < this.panchayat_dropdownItems.length; k++) {
                if (
                  this.product.grampanchayat_code[c] ==
                  this.panchayat_dropdownItems[k].value
                ) {
                  this.panchayat_dropdownItem.push({
                    name: this.panchayat_dropdownItems[k].name,
                    value: this.panchayat_dropdownItems[k].value,
                  });
                }
              }
            }
          }
        }
      });
    },
    async filterJsonByDistrictCodes(districtCodes, jsonData) {
      if (districtCodes.length > 0) {
        return jsonData
          .filter((item) => {
            return districtCodes.includes(item["district_code"]);
          })
          .map((item) => item);
      } else {
        return jsonData;
      }
    },
    async getBlockData() {
      this.block_dropdownItem = null;
      this.block_dropdownItems = [];
      var district_code = [];
      for (var d = 0; d < this.district_dropdownItem.length; d++) {
        district_code.push(this.district_dropdownItem[d].value);
      }
      var blocks = await this.filterJsonByDistrictCodes(
        district_code,
        this.$store.getters.getBlocks
      );
      if (blocks.length > 0) {
        this.block_dropdownItems = blocks.map((item) => ({
          name: item["name"],
          value: item["code"],
        }));
      }
    },
    get_location() {
      this.place_details = "";
      var data = { PlaceId: this.location_search.value };
      var promise = apis.geocodelocationdetails(data);
      promise.then((response) => {
        if (response.data.result) {
          this.place_details = response.data.result[0];
        }
      });
    },
    dropdown_list(search) {
      var data = { search: search.value };
      var promise = apis.geocodelats(data);
      promise.then((response) => {
        this.location_dropdown = [];
        var temp = response.data.result;
        for (let a = 0; a < temp.length; a++) {
          this.location_dropdown.push({
            name: temp[a].Text,
            value: temp[a].PlaceId,
          });
        }
      });
    },
    async search(count) {
      if (count == 2) {
        this.center_name = "";
        this.center_status = null;
        this.centertypeitem = null;
        this.showFirstFilter = false;
        this.village_dropdownItem = null;
        this.block_dropdownItem = null;
        this.district_dropdownItem = null;
        this.panchayat_dropdownItem = null;
        await this.getBlockData();
        await this.get_panchayat();
        await this.get_village();
      }
      await this.get_list();
      await this.get_count();
    },
    async editProduct(product) {
      this.file_attachment = "";
      this.product = { ...product };
      this.productDialog = true;
      this.selectstatus = { name: "", value: "" };
      this.state_dropdownItem = { name: "", value: "" };
      if (this.product.status) {
        this.selectstatus.value = this.product.status;
        this.selectstatus.name = this.product.status;
      }
      this.add_center_type = [];
      for (let ZX = 0; ZX < this.centertypeitems.length; ZX++) {
        if (
          this.product.center_type_code == this.centertypeitems[ZX].id &&
          this.product.center_type_name == this.centertypeitems[ZX].name
        ) {
          this.add_center_type = {
            _id: this.centertypeitems[ZX]._id,
            id: this.product.center_type_code,
            name: this.product.center_type_name,
          };
        }
      }
      this.location_search = {
        name: this.product.center_location
          ? this.product.center_location.Label
          : "",
        value: this.product.center_location ? this.product.center_location : "",
      };
      this.place_details = this.product.center_location
        ? this.product.center_location
        : "";
      if (this.product.district_code.length > 0) {
        this.district_dropdownItem = [];
        for (let c = 0; c < this.product.district_code.length; c++) {
          for (let k = 0; k < this.district_dropdownItems.length; k++) {
            if (
              this.product.district_code[c] ==
              this.district_dropdownItems[k].value
            ) {
              this.district_dropdownItem.push({
                name: this.district_dropdownItems[k].name,
                value: this.district_dropdownItems[k].value,
              });
            }
          }
        }
      }
      if (this.product.block_code.length > 0) {
        this.show_block = true;
        this.block_dropdownItem = [];
        for (let c = 0; c < this.product.block_code.length; c++) {
          for (let k = 0; k < this.block_dropdownItems.length; k++) {
            if (
              this.product.block_code[c] == this.block_dropdownItems[k].value
            ) {
              this.block_dropdownItem.push({
                name: this.block_dropdownItems[k].name,
                value: this.block_dropdownItems[k].value,
              });
            }
          }
        }
      }
      await this.get_panchayat(1);
      await this.get_village(2);
    },
    isNumber(evt) {
      const charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      }
    },
    async onPage(event) {
      this.lazyParams = event;
      this.page_no = event.page + 1;
      this.limit = event.rows;
      if (this.totalRecords > 0) {
        this.get_list();
      }
    },
    get_count: function () {
      var block_code = [];
      var district_code = [];
      var village_code = [];
      var panchayat_code=[];
      if (this.block_dropdownItem) {
        for (var c = 0; c < this.block_dropdownItem.length; c++) {
          block_code.push(this.block_dropdownItem[c].value);
        }
      }
      if (this.district_dropdownItem) {
        for (var d = 0; d < this.district_dropdownItem.length; d++) {
          district_code.push(this.district_dropdownItem[d].value);
        }
      }
      if (this.panchayat_dropdownItem) {
        for (var f = 0; f < this.panchayat_dropdownItem.length; f++) {
          panchayat_code.push(this.panchayat_dropdownItem[f].value);
        }
      }
      if (this.village_dropdownItem) {
        for (var e = 0; e < this.village_dropdownItem.length; e++) {
          village_code.push(this.village_dropdownItem[e].value);
        }
      }
      var data = {
        count: true,
        center_name: this.center_name,
        district_code: district_code,
        block_code: block_code,
        village_code: village_code,
        panchayat_code: panchayat_code,
        status: this.center_status == null ? "" : this.center_status.value,
        center_type: this.centertypeitem == null ? "" : this.centertypeitem.id,
      };
      this.loading = true;
      var promise = apis.centerList(data);
      promise.then((response) => {
        this.loading = false;
        this.totalRecords = response.data.data;
      });
    },
    get_list: function () {
      var block_code = [];
      var district_code = [];
      var village_code = [];
      var panchayat_code=[];
      if (this.block_dropdownItem) {
        for (var c = 0; c < this.block_dropdownItem.length; c++) {
          block_code.push(this.block_dropdownItem[c].value);
        }
      }
      if (this.district_dropdownItem) {
        for (var d = 0; d < this.district_dropdownItem.length; d++) {
          district_code.push(this.district_dropdownItem[d].value);
        }
      }
      if (this.panchayat_dropdownItem) {
        for (var f = 0; f < this.panchayat_dropdownItem.length; f++) {
          panchayat_code.push(this.panchayat_dropdownItem[f].value);
        }
      }
      if (this.village_dropdownItem) {
        for (var e = 0; e < this.village_dropdownItem.length; e++) {
          village_code.push(this.village_dropdownItem[e].value);
        }
      }
      var data = {
        limit: this.limit,
        page_no: this.page_no,
        count: false,
        district_code: district_code,
        block_code: block_code,
        village_code: village_code,
        panchayat_code:panchayat_code,
        center_name: this.center_name,
        center_type: this.centertypeitem == null ? "" : this.centertypeitem.id,
        status: this.center_status == null ? "" : this.center_status.value,
      };
      this.loading = true;
      var promise = apis.centerList(data, this.id);
      promise.then((response) => {
        this.loading = false;
        console.log(response);
        this.products = response.data.data;
        console.log(this.products[0]);
        if (this.columns.length == 0) {
          if (this.products.length > 0) {
            this.columns = Object.keys(this.products[0]);
          }
        }
      });
      console.log(data);
    },
    openNew() {
      this.product = {};
      this.submitted = false;
      this.productDialog = true;
      this.selectstatus = null;
    },
    hideDialog() {
      this.productDialog = false;
      this.submitted = false;
    },
    dateFormatYMD(inputDate) {
      var postdate = inputDate;
      if (inputDate) {
        inputDate = new Date(inputDate);
        if (inputDate.toString() == "NaN-NaN-NaN") {
          return postdate;
        } else {
          let date = ("0" + inputDate.getDate()).slice(-2);
          // current month
          let month = ("0" + (inputDate.getMonth() + 1)).slice(-2);
          // current year
          let year = inputDate.getFullYear();
          if (date.toString() == "aN") {
            return postdate;
          } else {
            return date + "-" + month + "-" + year;
          }
        }
      } else {
        return "";
      }
    },
    async add_update_center() {
      this.submitted = true;
      if (!this.product.center_name) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Enter Event Name",
          life: 3000,
        });
        return false;
      }
      if (!this.selectstatus.value) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Select Status",
          life: 3000,
        });
        return false;
      }
      var block_code = [];
      var district_code = [];
      var village_code = [];
      var panchayat_code = [];
      if (this.block_dropdownItem) {
        for (var c = 0; c < this.block_dropdownItem.length; c++) {
          block_code.push(this.block_dropdownItem[c].value);
        }
      }
      if (this.district_dropdownItem) {
        for (var d = 0; d < this.district_dropdownItem.length; d++) {
          district_code.push(this.district_dropdownItem[d].value);
        }
      }
      if (this.village_dropdownItem) {
        for (var e = 0; e < this.village_dropdownItem.length; e++) {
          village_code.push(this.village_dropdownItem[e].value);
        }
      }
      if (this.panchayat_dropdownItem) {
        for (var f = 0; f < this.panchayat_dropdownItem.length; f++) {
          panchayat_code.push(this.panchayat_dropdownItem[f].value);
        }
      }
      //edit
      if (this.product._id) {
        var data = {
          _id: this.product._id,
          center_name: this.product.center_name,
          center_type: this.add_center_type.id,
          center_location: this.place_details,
          status: this.selectstatus.value,
          created_by: localStorage.getItem("id"),
          district_code: district_code,
          village_code: village_code,
          block_code: block_code,
          grampanchayat_code: panchayat_code,
          client_id: this.client_dropdownItem._id
            ? this.client_dropdownItem._id
            : localStorage.getItem("client_id"),
        };
        this.isLoadingModel = true;
        var promise = apis.editcenter(data);
        promise
          .then((responseapi) => {
            this.$swal(responseapi.data.message);
            this.isLoadingModel = false;
            this.productDialog = false;
            this.get_list();
            this.get_count();
          })
          .catch((error) => {
            //console.log(error);
            this.isLoadingModel = false;
            this.productDialog = false;
            this.$swal.fire(error.response.data);
            this.get_list();
            this.get_count();
          });
      }
      //add-----------------------------------------------------------------------------------------------------------------
      else {
        var data1 = {
          center_name: this.product.center_name,
          center_type: this.add_center_type.id,
          center_location: this.place_details,
          status: this.selectstatus.value,
          created_by: localStorage.getItem("id"),
          district_code: district_code,
          village_code: village_code,
          block_code: block_code,
          grampanchayat_code: panchayat_code,
          client_id: this.client_dropdownItem._id
            ? this.client_dropdownItem._id
            : localStorage.getItem("client_id"),
        };
        this.isLoadingModel = true;
        var promises = apis.addcenter(data1);
        promises
          .then((response) => {
            this.isLoadingModel = false;
            this.productDialog = false;
            this.$swal(response.data.message);
            this.get_list();
            this.get_count();
          })
          .catch((error) => {
            //console.log(error);
            this.isLoadingModel = false;
            this.productDialog = false;
            this.$swal.fire(error.response.data);
            this.get_list();
            this.get_count();
          });
      }
    },
    confirmDeleteProduct(product) {
      this.product = product;
      this.deleteProductDialog = true;
    },
    deletecenter() {
      if (this.product._id) {
        var data = {
          _id: this.product._id,
          updated_by: localStorage.getItem("id"),
        };
        this.isLoadingModel = true;
        var promise = apis.deletecenter(data);
        promise.then((responseapi) => {
          this.isLoadingModel = false;
          if (responseapi.data.status == true) {
            // this.hideDialog1();
            this.deleteProductDialog = false;
            this.$swal(responseapi.data.message);
            this.get_list();
            this.get_count();
          } else {
            this.$swal("error to Delete Center");
          }
        });
      }
    },
    findIndexById(id) {
      let index = -1;
      for (let i = 0; i < this.products.length; i++) {
        if (this.products[i].id === id) {
          index = i;
          break;
        }
      }
      return index;
    },
    createId() {
      let id = "";
      var chars =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      for (var i = 0; i < 5; i++) {
        id += chars.charAt(Math.floor(Math.random() * chars.length));
      }
      return id;
    },
    async exportCSV() {
      this.limit = this.totalRecords;
      this.get_list();
      await this.$refs.dt.exportCSV();
    },
    confirmDeleteSelected() {
      this.deleteProductsDialog = true;
    },
    deleteSelectedProducts() {
      this.products = this.products.filter(
        (val) => !this.selectedProducts.includes(val)
      );
      this.deleteProductsDialog = false;
      this.selectedProducts = null;
      this.$toast.add({
        severity: "success",
        summary: "Successful",
        detail: "Products Deleted",
        life: 3000,
      });
    },
    initFilters() {
      this.filters = {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      };
    },
  },
  components: {},
};
</script>
<style scoped lang="scss">
@import "../assets/demo/badges.scss";
@import "../assets/demo/documentation.scss";

.icons-list {
  i {
    color: var(--text-color-secondary);
  }
}
</style>
  